import { configureStore } from '@reduxjs/toolkit'
import authReducer from './Slices/Auth';
import projectReducer from './Slices/projectReducer'
import productReducer from './Slices/productReducer';
import sectionSlice from './Slices/sectionSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    project: projectReducer,
    products: productReducer,
    section: sectionSlice,
  },
})


export default store;


